import { combineReducers } from 'redux';
import queryByStoreReducer from './query-by-store/reducer';
import organizationUnitsReducer from './organizationUnits/reducer';
import libraryReducer from './library/reducer';
import countriesReducer from './countries/reducer';
import statesReducer from './states/reducer';
import themeReducer from './theme/reducer';
import userProfileReducer from './userProfile/reducer';
import storesReducer from './stores/reducer'
import userReducer from './user/reducer';
import settingsReducer from './settings/reducer';
import channelReducer from './channel/reducer';
import tenantsReducer from './tenants/reducer';
import departmentsReducer from './departments/reducer';
import uploadFilesReducer from './upload-files/reducer';
import addressBooksReducer from './address-books/reducer';
import globalOrgRegistrationsReducer from './global-org-registrations/reducer';
import globalDbnTaxonomyDomainsReducer from './global-dbn-taxonomy-domains/reducer';
import globalDbnTaxonomyCategoriesReducer from './global-dbn-taxonomy-categories/reducer';
import openNetworkProductTypesReducer from './opennetwork-product-types/reducer';
import businessReducer from './businesses/reducer';
import businessUserReducer from './business-users/reducer';
import domainsReducer from './domains/reducer';
import networksReducer from './networks/reducer';
import channelsReducer from './channels/reducer';
import featuresReducer from './features/reducer';
import tenantDomainFunctionReducer from './TenantDomainFunctions/reducer';
import tenantDomainFunctionEntityReducer from './tenant-domain-function-entities/reducer';
import programsReducer from './programs/reducer';
import subscriptionsReducer from './subscriptions/reducer';
import applicationReducer from './applications/reducer';
import tenantDomainReducer from './tenant-domains/reducer';
import endpointReducer from './endpoints/reducer';
import environmentReducer from './environments/reducer';
import phasesReducer from './phases/reducer';
import digitalPrivateInfrastructureReducer from './digital-private-infrastructures/reducer';
import digitalPublicInfrastructureReducer from './digital-public-infrastructures/reducer';
import servicesReducer from './services/reducer';
import razorpayReducer from './razporpay/reducer';
import dbnpReducer from './dbnp/reducer';
import accountTypesReducer from './account-types/reducer';
import accountsReducer from './accounts/reducer';
import globalDBNPRegistrationsReducer from './global-dbnp-registrations/reducer';
import globalDBNPMappingsReducer from './dbnp-mappings/reducer';
import openNetworkRegistrationsReducer from './open-network-registrations/reducer';
import globalEANsReducer from './global-eans/reducer';
import globalOrgRegistryMappingsReducer from './global-org-registry-mappings/reducer';
import globalCatalogReducer from './global-catalog/reducer';
import platformWebsitesReducer from './platform-websites/reducer';
import accountWebPageCardsReducer from './web-page-cards/reducer';
import accountWebPagesReducer from './web-pages/reducer';
import policyCollectionsReducer from './organization/collections/reducer';
import routerReducer from './router/reducer';
import cancelReasonsReducer from './cancel-reasons/reducer';
import metaTokensReducer from './meta-token/reducer'
import edgeGatewaysReducer from './edge/gateways/reducer';
import dbasReducer from './dbas/reducer';
import gatewaysReducer from './gateways/reducer';
import globalDBARegistriesReducer from './global-dba-registries/reducer';
import globalDbnTaxonomySubDomainAttributesReducer from './global-dbn-taxonomy-sub-domain-attributes/reducer';
import globalDbnTaxonomySubDomainAttributesCategoryMappingsReducer from './global-dbn-taxonomy-sub-domain-attributes-category-mappings/reducer';
import gatewayRegistriesReducer from './gateway-registries/reducer';
import globalDbnAgentsReducer from './global-dbn-agents/reducer';
import licenseReducer from './licenses/reducer';
import globalDBNAgentMappingsReducer from './global-DBN-Agent-mappings/reducer';
import globalParsingRulesReducer from './global-parsing-rules/reducer';
import tenantFunctionsReducer from './tenant-functions/reducer';
import templatesReducer from './templates/reducer';
import partnersReducer from './partners/reducer';
import globalHSCodesReducer from './global-hs-codes/reducer';
import platformDBAServicesReducer from './platform-dba-services/reducer';
import channelProgramsReducer from './channel-program/reducer';
import { dodProgramParticipants } from './dod-program-participants/action';
import dodProgramParticipantReducer from './dod-program-participants/reducer';
import globalIssueCategoriesReducer from './global-issue-categories/reducer';
import globalServiceTypesReducer from './global-iship-cloud/global-service-types/reducer';
import globalBranchesReducer from './global-iship-cloud/global-branches/reducer';
import globalLoopsReducer from './global-iship-cloud/global-loops/reducer';
import globalPinCodesReducer from './global-iship-cloud/global-pin-codes/reducer';
import globalStdCodesReducer from './global-iship-cloud/global-std-codes/reducer';
import globalIndustryCodesReducer from './global-iship-cloud/global-industry-codes/reducer';
import globalNicCodesReducer from './global-iship-cloud/global-nic-codes/reducer';
import globalSwitchesReducer from './global-iship-cloud/global-switches/reducer';
import globalRoutingModelsReducer from './global-iship-cloud/global-routing-models/reducer';
import globalOBNDBNBizsReducer from './obn-dbn-bizs/reducer';
import brandMappingsReducer from './brand-mappings/reducer';
import dbnpRegistriesReducer from './dbnp-registries/reducer';
import shippingProvidersReducer from './shipping-providers/reducer';
import shippingTypesReducer from './shipping-types/reducer';
import globalDBNBizMappingsReducer from './obnnp-global-dbn-biz-mappings/reducer';
import globalDBNAgentMappingReducer from './obnnp-global-dbn-agent-mappings/reducer';
import globalBizNetTypesReducer from './global-biz-net-types/reducer';
import globalOBNAgentsReducer from './global-obn-agents/reducer';
import globalAgentNetTypesReducer from './global-agent-net-types/reducer';
import obnpMappingsReducer from './obnp-mappings/reducer';
import openNetworkRegistriesReducer from './open-network-registries/reducer';
import globalLogisticsCatalogReducer from './global-logistics/reducer';
import shipxAgencyMappingsReducer from './shipx-agency-mappings/reducer';
import globalDbnServiceCategoriesReducer from './global-dbn-service-category/reducer';
import globalDbnServiceCategorieReducer from './global-dbn-service-category/reducer';
import globalDbnTaxonomySubCategoriesReducer from './global-dbn-taxonomy-subcategory/reducer';
import routingModelsReducer from './global-dbn-routing-models/reducer';
import bluePrintRegistriesReducer from './global-dbn-blueprint-registry/reducer';
import globalDbnSubscriptionMemberReducer from './global-pack-subscription-member.tsx/reducer';
import globalDBNRoutingPacksReducer from './global-routing-packs/reducer';
import routingPacksReducer from './global-routing-packs/reducer';
import AdminLevelOneReducer from './admin-level-one/reducer';
import AdminLevelTwoReducer from './admin-level-two/reducer';
import AdminLevelThreeReducer from './admin-level-three/reducer';
import AdminLevelFourReducer from './admin-level-four/reducer';
import AdminLevelCityReducer from './city/reducer';
import AdminLevelPincodeReducer from './pincode/reducer';
import GlobalDodAgencyMappingReducer from './dod-agency-mapping/reducer';
import GlobalShipXAgencyMappingsReducer from './global-shipx-agency/reducer';
import PackagingTypeReducer from './packaging-types/reducer';
import ProductNatureReducer from './product-nature/reducer';

const appReducer = combineReducers({
	shipxAgencyMappings: shipxAgencyMappingsReducer,
	globalLogisticsCatalog: globalLogisticsCatalogReducer,
	obnpMappings: obnpMappingsReducer,
	globalOBNAgents: globalOBNAgentsReducer,
	globalAgentNetTypes: globalAgentNetTypesReducer,
	globalBizNetTypes: globalBizNetTypesReducer,
	globalDBNAgentMapping: globalDBNAgentMappingReducer,
	globalDBNBizMappings: globalDBNBizMappingsReducer,
	globalOBNDBNBizs: globalOBNDBNBizsReducer,
    brandMappings: brandMappingsReducer,
    dbnpRegistries: dbnpRegistriesReducer,
    shippingProviders: shippingProvidersReducer,
    shippingTypes: shippingTypesReducer,
	dodProgramParticipants: dodProgramParticipantReducer,
	channelPrograms: channelProgramsReducer,
	platformDBAServices: platformDBAServicesReducer,
	partners: partnersReducer,
	globalDBNAgentMappings: globalDBNAgentMappingsReducer,
	licenses: licenseReducer,
	globalDbnAgents: globalDbnAgentsReducer,
	gatewayRegistries: gatewayRegistriesReducer,
	globalDBARegistries: globalDBARegistriesReducer,
	gateways: gatewaysReducer,
	dbas: dbasReducer,
	metaTokens: metaTokensReducer,
	policyCollections: policyCollectionsReducer,
	accountWebPages: accountWebPagesReducer,
	accountWebPageCards: accountWebPageCardsReducer,
	platformWebsites: platformWebsitesReducer,
	globalCatalog: globalCatalogReducer,
	globalOrgRegistryMappings: globalOrgRegistryMappingsReducer,
	openNetworkRegistrations: openNetworkRegistrationsReducer,
	globalDBNPMappings: globalDBNPMappingsReducer,
	globalDBNPRegistrations: globalDBNPRegistrationsReducer,
	accountTypes: accountTypesReducer,
	accounts: accountsReducer,
	razporpay: razorpayReducer,
	settings: settingsReducer,
	theme: themeReducer,
	user: userReducer,
	channel: channelReducer,
	queryByStore: queryByStoreReducer,
	organizationUnits: organizationUnitsReducer,
	library: libraryReducer,
	countries: countriesReducer,
	states: statesReducer,
	userProfile: userProfileReducer,
	stores: storesReducer,
	tenants: tenantsReducer,
	departments: departmentsReducer,
	uploadFiles: uploadFilesReducer,
	addressBooks: addressBooksReducer,
	globalOrgRegistrations: globalOrgRegistrationsReducer,
	globalDbnTaxonomyDomains: globalDbnTaxonomyDomainsReducer,
	globalDbnTaxonomyCategories: globalDbnTaxonomyCategoriesReducer,
	openNetworkProductTypes: openNetworkProductTypesReducer,
	business: businessReducer,
	businessUser: businessUserReducer,
	domains: domainsReducer,
	networks: networksReducer,
	channels: channelsReducer,
	features: featuresReducer,
	tenantDomainFunctions: tenantDomainFunctionReducer,
	tenantDomainFunctionEntities: tenantDomainFunctionEntityReducer,
	programs: programsReducer,
	subscriptions: subscriptionsReducer,
	tenantDomains: tenantDomainReducer,
	applications: applicationReducer,
	endpoints: endpointReducer,
	environments: environmentReducer,
	phases: phasesReducer,
	digitalPrivateInfrastructures: digitalPrivateInfrastructureReducer,
	digitalPublicInfrastructures: digitalPublicInfrastructureReducer,
	services: servicesReducer,
	dbnp: dbnpReducer,
	globalEANs: globalEANsReducer,
	globalHSCodes: globalHSCodesReducer,
	router: routerReducer,
	cancelReasons: cancelReasonsReducer,
	edgeGateways: edgeGatewaysReducer,
	globalDbnTaxonomySubDomainAttributes: globalDbnTaxonomySubDomainAttributesReducer,
	globalDbnTaxonomySubDomainAttributesCategoryMappings: globalDbnTaxonomySubDomainAttributesCategoryMappingsReducer,
	globalParsingRules: globalParsingRulesReducer,
	tenantFunctions: tenantFunctionsReducer,
	templates: templatesReducer,
	globalIssueCategories: globalIssueCategoriesReducer,
	globalDbnServiceCategories: globalDbnServiceCategoriesReducer,
	globalDbnTaxonomySubCategories: globalDbnTaxonomySubCategoriesReducer,
	routingModels:routingModelsReducer,
	bluePrintRegistries:bluePrintRegistriesReducer,
	routingPacks:routingPacksReducer,
	globalDbnSubscriptionMember: globalDbnSubscriptionMemberReducer,
	AdminLevelOne:AdminLevelOneReducer,
	PackagingType:PackagingTypeReducer,
	ProductNature : ProductNatureReducer,
	AdminLevelTwo: AdminLevelTwoReducer,
	AdminLevelThree: AdminLevelThreeReducer,
	AdminLevelFour:AdminLevelFourReducer,
	AdminLevelCity:AdminLevelCityReducer,
	AdminLevelPincode: AdminLevelPincodeReducer,
	GlobalDodAgencyMapping: GlobalDodAgencyMappingReducer,
	GlobalShipXAgencyMappings :GlobalShipXAgencyMappingsReducer,	//Logistics
	globalServiceTypes: globalServiceTypesReducer,
	globalBranches: globalBranchesReducer,
	globalLoops: globalLoopsReducer,
	globalPinCodes: globalPinCodesReducer,
	globalStdCodes: globalStdCodesReducer,
	globalIndustryCodes: globalIndustryCodesReducer,
	globalNicCodes: globalNicCodesReducer,
	globalSwitches: globalSwitchesReducer,
	globalRoutingModels: globalRoutingModelsReducer,
	openNetworkRegistries: openNetworkRegistriesReducer
});

const rootReducer = (state: any, action: any) => {

	return appReducer(state, action);
};

export default rootReducer;
